<div class="layout-column custom-panel full-width full-height">
  <div class="flex layout-column padding-10 gap-10 overflow-auto">

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="resources-sort-name"
         (click)="onToggleSortTypeChange('allocationName' , sortBy === 'allocationName' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Name</span>
      <bringoz-icon *ngIf="sortBy === 'allocationName' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'allocationName' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="resources-sort-routes-count"
         (click)="onToggleSortTypeChange('routesCount', sortBy === 'routesCount' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>PLANNING_DRAFT_RESOURCES_VIEW_SETTINGS.routesCount</span>
      <bringoz-icon *ngIf="sortBy === 'routesCount' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'routesCount' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="resources-sort-tags"
         (click)="onToggleSortTypeChange('tags', sortBy === 'tags' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Tags</span>
      <bringoz-icon *ngIf="sortBy === 'tags' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'tags' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>
  </div>
</div>
